export default __webpack_public_path__ + "static/media/final_all_parcels.88b53397.geojson";